// extracted by css-extract-rspack-plugin
export default {"TimeAxis":"TimeAxis--BNQJ9"};